import { Badge } from '@startupquickstart/frontend';

interface MaxCompletionsBadgeProps {
  maxCompletions: number;
}

/** Badge showing the max number of teams that can complete a challenge */
export function MaxCompletionsBadge({ maxCompletions }: MaxCompletionsBadgeProps) {
  return (
    <Badge variant="outline" className="text-xs px-1.5 py-0 h-5 text-amber-600 border-amber-300">
      First {maxCompletions} {maxCompletions === 1 ? 'team' : 'teams'}
    </Badge>
  );
}
